export default "__VITE_ASSET__C6ONiVZs__"